<template>
  <div>
    <div class="pb3 border ttu b f6">
      <slot name="header" />
    </div>
    <div class="pt3 content-layout">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['state']
}
</script>

<style lang="scss" scoped>
.content-layout {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-row-gap: .5rem;
  align-items: start;
}
.border {
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-color: #F0F4F8
}
</style>
